import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, TextField,
} from '@mui/material';

import { kundeAendern, kundeErstellen } from '../api';
import { fehlertext } from '../utils/format';

const LEER = {
  name: '', anzeigename: '', ansprechpartner: '', kontakt_email: '', telefon: '', notiz: '',
  ist_testkunde: false, erinnerung_an_kunde: false,
};

// kunde == null: neuer Kunde. onFertig bekommt den gespeicherten Kunden.
export default function KundeDialog({ offen, kunde, onFertig, onZu }) {
  const [f, setF] = useState(LEER);
  const [fehler, setFehler] = useState('');
  const [laedt, setLaedt] = useState(false);
  const setze = (teil) => setF((alt) => ({ ...alt, ...teil }));

  useEffect(() => {
    if (!offen) return;
    setFehler('');
    setF(kunde ? {
      name: kunde.name ?? '', anzeigename: kunde.anzeigename ?? '', ansprechpartner: kunde.ansprechpartner ?? '',
      kontakt_email: kunde.kontakt_email ?? '', telefon: kunde.telefon ?? '', notiz: kunde.notiz ?? '',
      ist_testkunde: !!kunde.ist_testkunde, erinnerung_an_kunde: !!kunde.erinnerung_an_kunde,
    } : LEER);
  }, [offen, kunde]);

  if (!offen) return null;
  const nameFest = kunde && !kunde.name_aenderbar;

  const speichern = async () => {
    setLaedt(true);
    setFehler('');
    try {
      const r = kunde ? await kundeAendern(kunde.id, f) : await kundeErstellen(f);
      onFertig(r.data);
    } catch (e) {
      setFehler(fehlertext(e));
    } finally {
      setLaedt(false);
    }
  };

  return (
    <Dialog open onClose={laedt ? undefined : onZu} maxWidth="sm" fullWidth>
      <DialogTitle>{kunde ? 'Kunde bearbeiten' : 'Neuer Kunde'}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '8px !important' }}>
        {fehler && <Alert severity="error">{fehler}</Alert>}
        <TextField
          id="kunde-name" label="Lizenzname" value={f.name} required autoFocus={!kunde} disabled={nameFest}
          onChange={(e) => setze({ name: e.target.value })}
          helperText={nameFest
            ? 'Steht im Schlüssel des Kunden und lässt sich nach der Aktivierung nicht mehr ändern. Für das Portal den Anzeigenamen nutzen.'
            : 'Diesen Namen gibt der Kunde bei der Aktivierung ein; er erscheint in ProfiWare als Lizenznehmer.'}
        />
        <TextField
          id="kunde-anzeigename" label="Anzeigename im Portal" value={f.anzeigename}
          onChange={(e) => setze({ anzeigename: e.target.value })} helperText="Leer = Lizenzname"
        />
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
          <TextField id="kunde-ansprechpartner" label="Ansprechpartner" value={f.ansprechpartner} onChange={(e) => setze({ ansprechpartner: e.target.value })} />
          <TextField id="kunde-telefon" label="Telefon" value={f.telefon} onChange={(e) => setze({ telefon: e.target.value })} />
        </Box>
        <TextField id="kunde-email" label="E-Mail" type="email" value={f.kontakt_email} onChange={(e) => setze({ kontakt_email: e.target.value })} />
        <TextField id="kunde-notiz" label="Notiz" value={f.notiz} multiline minRows={2} onChange={(e) => setze({ notiz: e.target.value })} />
        <Box>
          <FormControlLabel
            control={<Switch checked={f.ist_testkunde} onChange={(e) => setze({ ist_testkunde: e.target.checked })} />}
            label="Testkunde – bekommt neue Versionen, bevor sie für alle freigegeben sind"
          />
          <FormControlLabel
            control={<Switch checked={f.erinnerung_an_kunde} onChange={(e) => setze({ erinnerung_an_kunde: e.target.checked })} />}
            label="Erinnerung vor Ablauf auch an die E-Mail des Kunden schicken"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onZu} disabled={laedt}>Abbrechen</Button>
        <Button variant="contained" onClick={speichern} disabled={laedt || !f.name.trim()}>
          {kunde ? 'Speichern' : 'Kunde anlegen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
